export default __webpack_public_path__ + "static/media/linkedin.31e304b2.svg";